// Supported UI languages. `ready: true` = fully usable (shown in the selector).
// Others exist in the catalogue but are hidden until the full UI is translated
// (many strings are still inline FR/EN). See CHANGELOG / i18n roadmap.
export const LANGUAGES = [
  { code: 'en', label: 'English', native: 'English', flag: '🇬🇧', ready: true },
  { code: 'fr', label: 'French', native: 'Français', flag: '🇫🇷', ready: true },
  { code: 'es', label: 'Spanish', native: 'Español', flag: '🇪🇸' },
  { code: 'pt', label: 'Portuguese', native: 'Português', flag: '🇧🇷' },
  { code: 'it', label: 'Italian', native: 'Italiano', flag: '🇮🇹' },
  { code: 'ja', label: 'Japanese', native: '日本語', flag: '🇯🇵' },
];

// All languages that exist in the translation catalogue.
export const SUPPORTED_LANGS = LANGUAGES.map((l) => l.code);
// Languages actually exposed to users right now (fully translated UI).
export const READY_LANGS = LANGUAGES.filter((l) => l.ready).map((l) => l.code);

// Preferred UI language per IDFC member institution (Phase 1 set; others default to English).
const INSTITUTION_LANGUAGE = {
  inst_afd: 'fr',
  inst_cdg: 'fr',
  inst_boad: 'fr',
  inst_bndes: 'pt',
  inst_jica: 'ja',
  inst_caf: 'es',
  inst_bcie: 'es',
  inst_bancoldex: 'es',
  inst_nafin: 'es',
  inst_cofide: 'es',
  inst_bice: 'es',
};

// Return the institution's preferred language only if it is currently READY,
// otherwise fall back to English (avoids showing a half-translated UI).
export const languageForInstitution = (institutionId) => {
  const pref = INSTITUTION_LANGUAGE[institutionId] || 'en';
  return READY_LANGS.includes(pref) ? pref : 'en';
};
